import { cn } from "../cn";
import { useTimedStateSequence } from "./useTimedStateSequence";

export type HighlightType = "flash" | "single" | "double";

const highlightClass = "bg-primary-100";
const fadeClass = "transition-colors";

const fadeDurationClassByType: Record<HighlightType, string> = {
  flash: "duration-150",
  single: "duration-300",
  double: "duration-300",
};

const sequenceByType: Record<
  HighlightType,
  { state: string; duration: number }[]
> = {
  flash: [
    { state: highlightClass, duration: 75 },
    { state: fadeClass, duration: getFadeDuration("flash") },
  ],
  single: [
    { state: highlightClass, duration: 300 },
    { state: fadeClass, duration: getFadeDuration("single") },
  ],
  double: [
    { state: highlightClass, duration: 50 },
    { state: "", duration: 50 },
    { state: highlightClass, duration: 100 },
    { state: fadeClass, duration: getFadeDuration("double") },
  ],
};

export function useHighlightClass(
  highlightType: HighlightType = "single",
): [string, () => void] {
  const [state, triggerHighlight] = useTimedStateSequence(
    sequenceByType[highlightType],
  );

  return [cn(fadeDurationClassByType[highlightType], state), triggerHighlight];
}

function getFadeDuration(type: HighlightType): number {
  return Number(fadeDurationClassByType[type].replace(/.*-/, ""));
}
